module.exports = __webpack_public_path__ + "img/landing_icon_1.70205e3b.png";